import { render, staticRenderFns } from "./integralStatistics.vue?vue&type=template&id=77885e0b&scoped=true&"
import script from "./integralStatistics.vue?vue&type=script&lang=js&"
export * from "./integralStatistics.vue?vue&type=script&lang=js&"
import style0 from "./integralStatistics.vue?vue&type=style&index=0&id=77885e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77885e0b",
  null
  
)

component.options.__file = "integralStatistics.vue"
export default component.exports